<ng-container *ngFor="let bound of bounds; index as boundIndex">
  <div class="l-section u-mt-pc-40 u-mt-tb-40 u-mt-sp-40">
    <div class="p-flight-bound">
      <div class="p-flight-bound__heading">
        <div class="p-flight-bound__heading-title c-icon-tooltip-list">
          <h2 class="c-bound-title01">{{ 'label.number.section.n' | staticMsg : { '0': boundIndex + 1 } }}</h2>
        </div>
      </div>
      <!-- 出発地点to到着地点、中継地点、出発日時表示 start -->
      <div class="p-flight-bound__bound02">
        <span class="p-flight-bound__fromto">
          <span class="p-flight-bound__fromto-from">{{ originLocationNameList[boundIndex] }}</span>
          <span class="p-flight-bound__fromto-separator">{{ 'label.section' | staticMsg }}</span>
          <span class="p-flight-bound__fromto-to">{{ destinationLocationNameList[boundIndex] }}</span>
        </span>
      </div>
      <div class="p-flight-bound__via" *ngIf="connectionLocationNameList[boundIndex]">
        {{ 'label.oneStopFlightLocation' | staticMsg : { '0': connectionLocationNameList[boundIndex] } }}
      </div>
      <div
        class="p-flight-bound__bound03"
        [innerHTML]="requestMock?.itineraries?.[boundIndex]?.departureDate ?? '' | dateFormat : 'default_departuredate'"
      ></div>
      <!-- 出発地点to到着地点、中継地点、出発日時表示 end -->
    </div>
    <!-- 旅程表示 start -->
    <div class="p-flight-container" [ngClass]="{ 'p-flight-container--applied': fareFamily?.isPromotionApplied }">
      <div class="p-flight-container__inner">
        <div class="p-flight-container__inner-item1">
          <!-- 遅延、早発表示 start-->
          <div class="p-flight-container__announce">
            <div class="p-flight-container__announce-item">
              <span class="c-tag c-tag--type01" *ngIf="bound.isContainedDelayedFlight"
                ><strong>{{ 'm_static_message-label.delayed' | staticMsg }}</strong></span
              >
              <span class="c-tag c-tag--type01" *ngIf="bound.isContainedEarlyDepartureFlight"
                ><strong>{{ 'm_static_message-label.earlyDeparture' | staticMsg }}</strong></span
              >
            </div>
          </div>
          <!-- 遅延、早発表示 end-->
          <!-- 時間変更（遅延、早発）の場合はclass追加 -->
          <div
            class="p-flight-container__plan"
            [ngClass]="{ 'p-flight-container__plan-government': isPc && bound.isContainedSubjectToGovernmentApproval }"
          >
            <div
              class="c-flight-plan"
              [ngClass]="{
                'c-flight-plan--change': this.flightPlanChange(bound)
              }"
            >
              <div class="c-flight-plan__time c-flight-plan__item-2">
                <!-- 時間変更有無で出し分け（出発時刻） start -->
                <!-- 時間変更あり start-->
                <ng-container *ngIf="bound.originDepartureEstimatedDateTime !== undefined; else notDepartureEstimated">
                  <!-- 変更前の時間設定 start-->
                  <div
                    class="c-flight-plan__time-box"
                    [innerHTML]="
                      bound.originDepartureDateTime ?? ''
                        | dateFormat : 'availability.flightPlan_departuredate.time.old' : true
                    "
                  ></div>
                  <!-- 変更前の時間設定 end-->
                  <!-- 変更後の時間設定 start -->
                  <ng-container *ngIf="isDepartureDateCheckList[boundIndex]; else notDepartureDateCheckList">
                    <div
                      class="c-flight-plan__time-box"
                      style="color: #d91829"
                      [innerHTML]="
                        bound.originDepartureEstimatedDateTime
                          | dateFormat : 'availability.flightPlan_departuredate.time.latest'
                      "
                    ></div>
                  </ng-container>
                  <ng-template #notDepartureDateCheckList>
                    <div class="c-flight-plan__time-box">
                      <span
                        style="color: #d91829"
                        [innerHTML]="
                          bound.originDepartureEstimatedDateTime
                            | dateFormat : 'flightPlan_departureArrivalDate.dateTime'
                        "
                      ></span>
                    </div>
                  </ng-template>
                  <div class="c-flight-plan__time-box">
                    <!-- 深夜表記部分 start -->
                    <span
                      class="c-flight-plan__time-text"
                      *ngIf="bound.flights?.[0]?.isLateNightDeparture"
                      [innerHTML]="
                        bound.originDepartureEstimatedDateTime
                          | dateFormat : 'default_departuredate.midnightTime' : true
                      "
                    >
                    </span>
                    <!-- 深夜表記部分 end -->
                  </div>
                  <!-- 変更後の時間設定 end -->
                </ng-container>
                <!-- 時間変更あり end-->

                <!-- 時間変更なし start-->
                <ng-template #notDepartureEstimated>
                  <div
                    class="c-flight-plan__time-box"
                    [innerHTML]="
                      bound.originDepartureDateTime ?? '' | dateFormat : 'availability.flightPlan_departuredate.time'
                    "
                  ></div>
                  <!-- 深夜表記部分 start -->
                  <div class="c-flight-plan__time-box">
                    <span class="custom-late-night-departure" *ngIf="bound.flights?.[0]?.isLateNightDeparture"
                      >{{
                        bound.originDepartureDateTime ?? '' | dateFormat : 'default_departuredate.midnightTime' : true
                      }}
                    </span>
                  </div>
                  <!-- 深夜表記部分 end -->
                </ng-template>
                <!-- 時間変更なし end-->
                <!-- 時間変更有無で出し分け（出発時刻） end -->
              </div>
              <div class="c-flight-plan__period c-flight-plan__period--0stop c-flight-plan__item-3">
                <p class="c-flight-plan__period-layover" *ngIf="bound.numberOfConnections === 0; else connection">
                  {{ 'm_static_message-label.directFlight' | staticMsg }}
                </p>
                <ng-template #connection>
                  <p class="c-flight-plan__period-layover">
                    {{ 'm_static_message-label.connectionCount' | staticMsg : { '0': bound.numberOfConnections } }}
                  </p>
                </ng-template>
                <p class="c-flight-plan__period-time" *ngIf="durationList[boundIndex] !== ''">
                  {{ durationList[boundIndex] | dateFormat : 'default_flightTotalTime' }}
                </p>
              </div>
              <div class="c-flight-plan__time c-flight-plan__item-5">
                <!-- 時間変更有無で出し分け（到着時刻） start -->
                <!-- 時間変更あり start-->
                <ng-container *ngIf="bound.destinationArrivalEstimatedDateTime !== undefined; else notArrivalEstimated">
                  <!-- 変更前の時間設定 start-->
                  <div
                    class="c-flight-plan__time-box"
                    [innerHTML]="
                      bound.destinationArrivalDateTime ?? ''
                        | dateFormat : 'availability.flightPlan_departuredate.time.old'
                    "
                  ></div>
                  <!-- 変更前の時間設定 end-->
                  <!-- 変更後の時間設定 start-->
                  <ng-container *ngIf="isArrivalDateCheckList[boundIndex]; else notArrivalDateCheckList">
                    <div
                      class="c-flight-plan__time-box"
                      style="color: #d91829"
                      [innerHTML]="
                        bound.destinationArrivalEstimatedDateTime
                          | dateFormat : 'availability.flightPlan_departuredate.time.latest'
                      "
                    ></div>
                  </ng-container>
                  <ng-template #notArrivalDateCheckList>
                    <div class="c-flight-plan__time-box">
                      <span
                        style="color: #d91829"
                        [innerHTML]="
                          bound.destinationArrivalEstimatedDateTime
                            | dateFormat : 'flightPlan_departureArrivalDate.dateTime'
                        "
                      ></span>
                    </div>
                  </ng-template>
                  <!-- 変更後の時間設定 end-->
                  <!-- 時間変更なし start-->
                </ng-container>
                <ng-template #notArrivalEstimated>
                  <div
                    class="c-flight-plan__time-box"
                    [innerHTML]="
                      bound.destinationArrivalDateTime ?? '' | dateFormat : 'availability.flightPlan_departuredate.time'
                    "
                  ></div>
                </ng-template>
                <!-- 時間変更なし end-->
                <!-- 時間変更有無で出し分け（到着時刻） end -->
              </div>
            </div>
          </div>

          <div class="p-flight-container__info">
            <div class="c-flight-detail-overview02">
              <div class="c-flight-detail-overview02__2col">
                <div class="c-flight-detail-overview02__2col-left">
                  <p class="c-flight-detail-overview02__2col-left-title">
                    {{ 'm_static_message-label.operate' | staticMsg }}
                  </p>
                  <div class="c-flight-detail-overview02__2col-left-item">
                    <!-- TODO: all complex-flight-availability 文言FIX後にaltタグの文言修正 -->
                    <span class="c-ana-icon01"
                      ><img
                        *ngIf="bound.isAllNhGroupOperated"
                        class="c-ana-icon01__img"
                        src="{{ appConstants.IMG.PARTNER_COMPANY_ICON }}"
                        width="{{ appConstants.IMG.LOGO_S_WIDTH }}"
                        height="{{ appConstants.IMG.LOGO_S_HEIGHT }}"
                        alt="{{ 'alt.nhFlight' | staticMsg }}"
                    /></span>
                    <!-- 運航キャリアリスト名称表示 start -->
                    <div *ngIf="!bound.isAllNhGroupOperated" class="c-flight-detail-overview02__2col-left-item-box">
                      <span class="c-asam-icon01">
                        <span
                          *ngIf="this.operatingAirlineList[boundIndex]"
                          [innerHTML]="
                            'label.sectionOpCarrierWording'
                              | staticMsg
                                : {
                                    '0': this.operatingAirlineList[boundIndex]
                                  }
                          "
                        ></span>
                      </span>
                    </div>
                    <!-- 運航キャリアリスト名称表示 end -->
                  </div>
                </div>
                <div class="c-flight-detail-overview02__2col-right">
                  <a
                    href="#"
                    class="c-text-link-arrow01 c-text-link-arrow01--s"
                    id="complex-flight-availability-flight-details-a"
                    (throttleClick$)="this.flightDetails($event, boundIndex)"
                    aswThrottleClick
                    >{{ 'm_static_message-label.details1' | staticMsg }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="p-flight-container__inner-item2">
          <div class="p-flight-container__fare p-flight-container__fare--seats">
            <div class="p-flight-container__fare-item p-flight-container__fare-item--2">
              <p
                class="p-flight-container__fare-item-seats"
                *ngIf="fareFamily?.airOffers?.[0]?.complexBounds?.[boundIndex]?.quotaType === 'available'"
              >
                <em>{{ 'm_static_message-label.remainSeat' | staticMsg }}</em>
              </p>
              <p
                class="p-flight-container__fare-item-seats"
                *ngIf="fareFamily?.airOffers?.[0]?.complexBounds?.[boundIndex]?.quotaType === 'few'"
              >
                <em>{{
                  'm_static_message-label.lastSeatWithSpan1'
                    | staticMsg: { '0': fareFamily?.airOffers?.[0]?.complexBounds?.[boundIndex]?.quota }
                }}</em>
              </p>
            </div>
            <div class="p-flight-container__fare-item p-flight-container__fare-item--3">
              <button
                class="c-btn-tertiary c-btn-tertiary--s"
                id="complex-flight-availability-changeByBound-{{ boundIndex }}-tertiary"
                (throttleClick$)="change($event, boundIndex)"
                aswThrottleClick
              >
                <span class="c-btn-tertiary__text" aria-hidden="true">{{
                  'm_static_message-label.showOtherFlight' | staticMsg
                }}</span>
                <span class="u-visually-hidden">{{
                  'reader.showOtherFlight.screenReader' | staticMsg : { '0': boundIndex + 1 }
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 旅程表示 end -->
  </div>
</ng-container>
